import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "item"]
  static values = { active: { type: String, default: "All" } }

  filter(event) {
    const value = event.currentTarget.dataset.filterValue
    this.activeValue = value
    this.update()
  }

  update() {
    this.buttonTargets.forEach(btn => {
      const isActive = btn.dataset.filterValue === this.activeValue
      btn.classList.toggle("bg-charcoal", isActive)
      btn.classList.toggle("text-white", isActive)
      btn.classList.toggle("border-charcoal", isActive)
      btn.classList.toggle("bg-bg-card", !isActive)
      btn.classList.toggle("text-fg-2", !isActive)
      btn.classList.toggle("border-border-strong", !isActive)
    })

    this.itemTargets.forEach(item => {
      const cats = (item.dataset.filterCategory || "").split(",")
      const show = this.activeValue === "All" || cats.includes(this.activeValue)
      item.classList.toggle("hidden", !show)
    })
  }
}
